export type CountryPhoneCode = {
    key: string;
    value: string;
    text: string;
    flag?: string;
};

export const countryPhoneCodes: CountryPhoneCode[] = [
    { value: '+7', text: '+7', key: '+7', flag: '🇷🇺' },
    { value: '+40', text: '+40', key: '+40', flag: '🇷🇴' },
    { value: '+380', text: '+380', key: '+380', flag: '🇺🇦' },
    { value: '+49', text: '+49', key: '+49', flag: '🇩🇪' },
    { value: '+33', text: '+33', key: '+33', flag: '🇫🇷' },
    { value: '+373', text: '+373', key: '+373', flag: '🇲🇩' },
];
